export const isImagePreview = preview => !!preview.dimensions;